import { configureStore } from "@reduxjs/toolkit";

import { agenticAiReducer } from "./agenticAiReducer";
import { initialAgenticAiState } from "./agenticAiState";

export const agenticAiStore = configureStore({
  reducer: {
    agenticAi: agenticAiReducer,
  },
  preloadedState: {
    agenticAi: initialAgenticAiState,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // We need to store tool callback functions in the store so that they can be
      // called by the agent, so we need to disable the serializable check.
      serializableCheck: false,
    }),
});
